import { addDays, format, isSameDay, startOfToday } from "date-fns";
import { it } from "date-fns/locale";
import { RESTAURANT } from "@/demo/menuData";

const hash = (s) => [...s].reduce((h, c) => (h * 31 + c.charCodeAt(0)) >>> 0, 7);

export const availability = (date, slot) => {
  const n = hash(format(date, "yyyy-MM-dd") + slot) % 7;
  if (n === 0) return "full";
  if (n === 1) return "few";
  return "ok";
};

export const DateStrip = ({ selected, onSelect, days = 14 }) => {
  const today = startOfToday();
  return (
    <div className="scrollbar-none -mx-1 flex gap-2 overflow-x-auto px-1 pb-1" data-testid="booking-dates">
      {Array.from({ length: days }, (_, i) => addDays(today, i)).map((d, i) => {
        const closed = RESTAURANT.closedDays.includes(d.getDay());
        const sel = isSameDay(d, selected);
        return (
          <button
            key={i}
            type="button"
            disabled={closed}
            onClick={() => onSelect(d)}
            data-testid={`booking-date-${i}`}
            aria-pressed={sel}
            className={`flex w-[62px] flex-none flex-col items-center rounded-2xl border py-2.5 transition-colors duration-300 ${
              sel
                ? "border-terracotta bg-terracotta text-[#1c0d08]"
                : closed
                  ? "cursor-not-allowed border-line text-faded/50 line-through"
                  : "border-line text-stone hover:border-line-strong hover:text-bone"
            }`}
          >
            <span className="font-accent text-[9px] uppercase tracking-[0.18em]">
              {i === 0 ? "Oggi" : format(d, "EEE", { locale: it })}
            </span>
            <span className="mt-0.5 font-serif text-xl leading-none">{format(d, "d")}</span>
            <span className="mt-0.5 text-[9px] uppercase opacity-70">{format(d, "MMM", { locale: it })}</span>
          </button>
        );
      })}
    </div>
  );
};

export const SlotGrid = ({ date, slots, selected, onSelect }) => (
  <div className="grid grid-cols-4 gap-2 sm:grid-cols-5" data-testid="booking-slots">
    {slots.map((s) => {
      const av = availability(date, s);
      const sel = selected === s;
      return (
        <button
          key={s}
          type="button"
          disabled={av === "full"}
          onClick={() => onSelect(s)}
          data-testid={`booking-slot-${s.replace(":", "")}`}
          aria-pressed={sel}
          className={`relative rounded-xl border py-2.5 text-sm transition-colors duration-300 ${
            sel
              ? "border-bone bg-bone text-ink"
              : av === "full"
                ? "cursor-not-allowed border-line text-faded/40 line-through"
                : "border-line text-bone hover:border-line-strong"
          }`}
        >
          {s}
          {av === "few" && !sel && (
            <span className="absolute -top-1.5 right-1.5 rounded-full bg-ochre px-1.5 py-px text-[8px] font-semibold uppercase tracking-wider text-ink">
              ultimi
            </span>
          )}
        </button>
      );
    })}
  </div>
);
